import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import type { DocumentSlot } from '@core/util/documentSlots.util';

interface UploadDocumentSlotProps {
  slot: DocumentSlot;
  onUploadClick: (slot: DocumentSlot) => void;
}

const UploadDocumentSlot: React.FC<UploadDocumentSlotProps> = ({
  slot,
  onUploadClick,
}) => {
  return (
    <div className="border-b border-gray-100 pb-4 last:border-b-0">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex-1">
          <div className="text-sm font-medium text-gray-900">
            {slot.title}
            {slot.required && (
              <span className="ml-1 text-red-500" aria-hidden="true">
                *
              </span>
            )}
          </div>
          <div className="mt-1 text-xs text-gray-500">
            File not uploaded yet.
            {slot.childQuestions.length > 0
              ? ' Upload to add file and document details.'
              : ' PDF, JPG, JPEG, PNG, HEIF, and HEIC are supported.'}
          </div>
        </div>

        <button
          type="button"
          onClick={() => onUploadClick(slot)}
          className="flex items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 sm:min-w-[120px]"
          title="Upload a document"
        >
          <FontAwesomeIcon icon={faUpload} className="h-4 w-4" />
          Upload
        </button>
      </div>
    </div>
  );
};

export default UploadDocumentSlot;
